import FormatDate from './FormatDate'

export default FormatDate
